import { PayLinkStepOption, PayLinkStepOptionPayload } from 'models';

export const SIGNUP_STEPS_STATE: PayLinkStepOptionPayload = {
  steps: [] as PayLinkStepOption[],
} as PayLinkStepOptionPayload;
